import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import loginBgDark from "assets/img/login_bg_dark.jpg";
import loginBgLight from "assets/img/login_bg_light.jpg";
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import CountrySelect from '../components/CountrySelect';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ThemeContext } from "components/Theme/ThemeContext";
import {
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  Button,
  Link
} from "@mui/material";

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: "2",
    position: "relative",
    paddingTop: "90px",
    color: "#FFFFFF",
    paddingBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flex: 1
  },
  form: {
    margin: "0"
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important",
    flexDirection: "column",
    gap: "12px",
    padding: "20px"
  },
  textField: {
    margin: "12px 0 20px 0 !important",
    width: "100%",
    "& label": {
      color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.6) !important" : "rgba(15, 23, 42, 0.6) !important",
      fontSize: "0.9rem",
    },
    "& label.MuiInputLabel-shrink": {
      background: ({ isDark }) => isDark ? "#0d0d0f" : "#ffffff",
      padding: "0 8px !important",
      marginLeft: "-4px"
    },
    "& label.Mui-focused": {
      color: "#E9AE31 !important",
    },
    "& .MuiOutlinedInput-root": {
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
      borderRadius: "12px",
      color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
      "& fieldset": {
        borderColor: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.15) !important" : "rgba(0, 0, 0, 0.15) !important",
        borderRadius: "12px",
        transition: "all 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(233, 174, 49, 0.6) !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31 !important",
        boxShadow: ({ isDark }) => isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
      },
      "& input": {
        padding: "14px 14px",
        color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
        caretColor: "#E9AE31 !important",
      }
    }
  },
  primaryButton: {
    background: "linear-gradient(135deg, #FFD066 0%, #E9AE31 50%, #C28F1B 100%) !important",
    color: "#0A0A0B !important",
    borderRadius: "50px !important",
    boxShadow: "0 4px 15px rgba(233, 174, 49, 0.25) !important",
    fontWeight: "700 !important",
    padding: "12px 24px !important",
    width: "100%",
    textTransform: "none !important",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 6px 20px rgba(233, 174, 49, 0.4) !important",
      background: "linear-gradient(135deg, #FFE08C 0%, #F5C242 50%, #D69E2E 100%) !important"
    },
    "&:active": {
      transform: "translateY(0)"
    }
  },
  secondaryButton: {
    background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.05) !important" : "rgba(0, 0, 0, 0.03) !important",
    color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
    borderRadius: "50px !important",
    border: ({ isDark }) => isDark ? "1px solid rgba(255, 255, 255, 0.2) !important" : "1px solid rgba(0, 0, 0, 0.15) !important",
    fontWeight: "600 !important",
    padding: "10px 24px !important",
    width: "100%",
    textTransform: "none !important",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
    "&:hover": {
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.1) !important" : "rgba(0, 0, 0, 0.06) !important",
      borderColor: "#E9AE31 !important",
      color: "#E9AE31 !important"
    }
  },
  checkboxLabel: {
    color: ({ isDark }) => isDark ? "#FFFFFF" : "#0F172A",
    fontSize: "0.9rem"
  },
  selectField: {
    color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
    background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
    borderRadius: "12px",
    "& .MuiSelect-select": {
      color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.1) !important" : "rgba(0, 0, 0, 0.08) !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(233, 174, 49, 0.6) !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9AE31 !important",
    },
    "& .MuiSelect-icon": {
      color: "#E9AE31 !important"
    }
  }
}));

export default function CompleteProfile() {
  const { isDark } = useContext(ThemeContext);
  const classes = useStyles({ isDark });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    countries,
    updateProfile,
    checkUserExists,
    requestMobileOtp,
    updateAuthMobile,
    signOff
  } = api;

  const { authRef, RecaptchaVerifier, linkWithPhoneNumber, unlink } = useContext(FirebaseContext);

  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);

  const [usertype, setUsertype] = useState('customer');
  const [mobileWithoutCountry, setMobileWithoutCountry] = useState('');
  const [countryData, setCountryData] = useState({
    country: '',
    selectedcountry: null
  });
  const [referralId, setReferralId] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [otpCalled, setOtpCalled] = useState(false);
  const [otp, setOtp] = useState('');
  const [confirmCodeFunction, setConfirmCodeFunction] = useState(null);

  useEffect(() => {
    if (settings && countries && countries.length > 0) {
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].label === settings.country) {
          setCountryData({
            country: countries[i].phone,
            selectedcountry: countries[i]
          });
        }
      }
    }
  }, [settings, countries]);

  useEffect(() => {
    // If the profile becomes complete, navigate away
    if (auth.profile && auth.profile.uid && auth.profile.mobile && auth.profile.mobile.trim() !== '' && auth.profile.usertype && auth.profile.usertype.trim() !== '') {
      if (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
        navigate('/dashboard');
      } else if (auth.profile.usertype === 'driver') {
        navigate('/driver-home');
      } else {
        navigate('/addbookings');
      }
    }
  }, [auth.profile, navigate]);

  const onCountryChange = (object, value) => {
    if (value) {
      setCountryData({
        country: value.phone,
        selectedcountry: value
      });
      setMobileWithoutCountry('');
    }
  };

  const handleLogout = () => {
    dispatch(signOff());
    navigate('/login');
  };

  const handleCommonAlertClose = () => {
    setCommonAlert({ open: false, msg: '' });
  };

  const handleCloseOtpDialog = () => {
    setOtp('');
    setOtpCalled(false);
    window.recaptchaVerifier = null;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (loading) return;

    if (!countryData.country) {
      setCommonAlert({ open: true, msg: t('country_blank_error') || "Please select country code." });
      return;
    }

    if (!mobileWithoutCountry || mobileWithoutCountry.trim().length < 6) {
      setCommonAlert({ open: true, msg: t('mobile_no_blank_error') || "Please enter a valid mobile number." });
      return;
    }

    if (!termsAccepted) {
      setCommonAlert({ open: true, msg: t('term_required') || "Please accept the Terms & Conditions." });
      return;
    }

    setLoading(true);
    const formattedNum = mobileWithoutCountry.replace(/ /g, '').replace(/-/g, '');
    const fullMobile = "+" + countryData.country + formattedNum;

    try {
      // Check if mobile number is already in use
      const res = await checkUserExists({ mobile: fullMobile });
      if (res.users && res.users.length > 0) {
        setLoading(false);
        setCommonAlert({ open: true, msg: t('user_exists') || "User already exists with this mobile number." });
        return;
      }
      if (res.error) {
        setLoading(false);
        setCommonAlert({ open: true, msg: t('email_or_mobile_issue') || "Verification issue. Try again." });
        return;
      }

      setOtpCalled(true);

      if (settings.customMobileOTP) {
        dispatch(requestMobileOtp(fullMobile));
        setLoading(false);
      } else {
        // Render Firebase invisible recaptcha
        window.recaptchaVerifier = new RecaptchaVerifier(authRef(), 'sign-in-button', {
          'size': 'invisible'
        });

        // Unlink if there is already a phone provider attached to this credential (unlikely for new user)
        if (authRef().currentUser.phoneNumber) {
          try {
            await unlink(authRef().currentUser, "phone");
          } catch (e) {
            console.log("Unlink phone failed", e);
          }
        }

        const linkObj = await linkWithPhoneNumber(authRef().currentUser, fullMobile, window.recaptchaVerifier);
        setConfirmCodeFunction(linkObj);
        setLoading(false);
      }
    } catch (error) {
      console.error("Verification error:", error);
      setLoading(false);
      setOtpCalled(false);
      if (window.recaptchaVerifier) window.recaptchaVerifier.clear();
      setCommonAlert({ open: true, msg: error.message || t('try_again') });
    }
  };

  const generateUniqueCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return [...Array(8)]
      .map((_) => chars[~~(Math.random() * chars.length)])
      .join("");
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6 || isNaN(otp)) {
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
      return;
    }

    setLoading(true);
    const formattedNum = mobileWithoutCountry.replace(/ /g, '').replace(/-/g, '');
    const fullMobile = "+" + countryData.country + formattedNum;

    try {
      if (settings.customMobileOTP) {
        const res = await updateAuthMobile(fullMobile, otp);
        if (res.success) {
          await completeRegistration(fullMobile);
        } else {
          setLoading(false);
          setOtp('');
          setCommonAlert({ open: true, msg: res.error === 'Error updating user' ? t('user_exists') : t('otp_validate_error') });
        }
      } else {
        if (confirmCodeFunction) {
          await confirmCodeFunction.confirm(otp);
          await completeRegistration(fullMobile);
        }
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setLoading(false);
      setOtp('');
      if (window.recaptchaVerifier) window.recaptchaVerifier.clear();
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
    }
    setOtpCalled(false);
    window.recaptchaVerifier = null;
  };

  const completeRegistration = async (fullMobile) => {
    const uniqueReferralId = generateUniqueCode();
    const updatedData = {
      mobile: fullMobile,
      usertype: usertype,
      approvedTerms: true,
      referralId: uniqueReferralId
    };

    if (referralId && referralId.trim().length > 0) {
      updatedData.signupViaReferral = referralId.trim().toUpperCase();
    }

    await dispatch(updateProfile(updatedData));
    setLoading(false);
    setCommonAlert({ open: true, msg: t('profile_updated') || "Registration complete!" });
  };

  return (
    <div
      style={{
        backgroundImage: "url(" + (isDark ? loginBgDark : loginBgLight) + ")",
        backgroundSize: "cover",
        backgroundPosition: "top center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Header
        color="transparent"
        brand={
          (settings && settings.appName && settings.appName !== "MOVE" && settings.appName !== "Move")
            ? settings.appName
            : "Rahl"
        }
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 80,
          color: isDark ? "dark" : "white"
        }}
      />
      <div className={classes.container}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} md={5}>
            <Card style={{ backgroundColor: isDark ? '#111215' : '#ffffff', border: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)' }}>
              <form className={classes.form} onSubmit={handleSubmit}>
                <CardHeader
                  style={{
                    background: "transparent",
                    boxShadow: "none",
                    marginTop: "10px",
                    marginBottom: "10px"
                  }}
                  className={classes.cardHeader}
                >
                  <Typography variant="h4" style={{ fontWeight: '700', fontFamily: 'Outfit, sans-serif', color: isDark ? '#ffffff' : '#0F172A', textShadow: isDark ? "0 0 10px rgba(233, 174, 49, 0.25)" : "none", textAlign: "center" }}>
                    {t('profile_title') || "Complete Profile"}
                  </Typography>
                </CardHeader>
                <CardBody style={{ padding: '20px' }}>
                  <Typography style={{ color: isDark ? 'rgba(255, 255, 255, 0.7)' : '#64748b', fontSize: '0.95rem', marginBottom: '20px', textAlign: 'center' }}>
                    {t('welcome_social_login') || "Welcome! Please complete the fields below to finish setting up your account."}
                  </Typography>

                  {/* Register As Role Selection */}
                  <FormControl className={classes.textField} variant="outlined">
                    <InputLabel style={{ color: isDark ? "rgba(255, 255, 255, 0.6)" : "rgba(15, 23, 42, 0.6)" }}>
                      {t('user_type') || "Register As"}
                    </InputLabel>
                    <Select
                      id="usertype"
                      className={classes.selectField}
                      value={usertype}
                      label={t('user_type') || "Register As"}
                      onChange={(e) => setUsertype(e.target.value)}
                    >
                      <MenuItem value="customer">{t('customer') || "Customer"}</MenuItem>
                      <MenuItem value="driver">{t('driver') || "Driver"}</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Country Selector */}
                  {countryData.selectedcountry && countries && countries.length > 0 && (
                    <FormControl className={classes.textField}>
                      <CountrySelect
                        countries={countries}
                        label={t('select_country') || "Select Country"}
                        value={countryData.selectedcountry}
                        onChange={onCountryChange}
                        readOnly={!settings.AllowCountrySelection}
                        style={{ width: '100%' }}
                        fieldStyle={{
                          "& label.Mui-focused": {
                            color: "#E9AE31 !important",
                          },
                          "& .MuiOutlinedInput-root": {
                            background: isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
                            borderRadius: "12px",
                            color: isDark ? "#FFFFFF !important" : "#0F172A !important",
                            "& fieldset": {
                              borderColor: isDark ? "rgba(255, 255, 255, 0.15) !important" : "rgba(0, 0, 0, 0.15) !important",
                              borderRadius: "12px",
                              transition: "all 0.3s ease",
                            },
                            "&:hover fieldset": {
                              borderColor: "rgba(233, 174, 49, 0.6) !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#E9AE31 !important",
                            },
                            "& input": {
                              color: isDark ? "#FFFFFF !important" : "#0F172A !important",
                            }
                          }
                        }}
                      />
                    </FormControl>
                  )}

                  {/* Mobile Phone Input */}
                  <FormControl className={classes.textField}>
                    <TextField
                      id="mobileWithoutCountry"
                      variant="outlined"
                      fullWidth
                      label={t('phone') || "Phone Number"}
                      value={mobileWithoutCountry}
                      onChange={(e) => setMobileWithoutCountry(e.target.value)}
                      placeholder={t('mobile') || "Enter phone number"}
                    />
                  </FormControl>

                  {/* Referral ID (Optional) */}
                  <FormControl className={classes.textField}>
                    <TextField
                      id="referralId"
                      variant="outlined"
                      fullWidth
                      label={t('referral_id_placeholder') || "Referral ID (Optional)"}
                      value={referralId}
                      onChange={(e) => setReferralId(e.target.value)}
                      placeholder={t('referral_id_placeholder') || "Referral ID"}
                    />
                  </FormControl>

                  {/* Terms and Conditions */}
                  <FormControlLabel
                    style={{ margin: '10px 0 0 0', width: '100%' }}
                    control={
                      <Checkbox
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                        style={{ color: '#E9AE31' }}
                      />
                    }
                    label={
                      <Typography className={classes.checkboxLabel}>
                        {t('accept_terms_prefix') || "I accept the "}
                        <Link href="/term-condition" target="_blank" style={{ color: '#E9AE31', textDecoration: 'underline' }}>
                          {t('term_condition') || "Terms & Conditions"}
                        </Link>
                      </Typography>
                    }
                  />

                </CardBody>
                <CardFooter className={classes.cardFooter}>
                  <div id="sign-in-button" />
                  {loading ? (
                    <CircularProgress style={{ color: '#E9AE31' }} />
                  ) : (
                    <>
                      <Button
                        type="submit"
                        className={classes.primaryButton}
                      >
                        {t('submit') || "Submit"}
                      </Button>
                      <Button
                        onClick={handleLogout}
                        className={classes.secondaryButton}
                      >
                        {t('logout') || "Log Out"}
                      </Button>
                    </>
                  )}
                </CardFooter>
              </form>
            </Card>
          </Grid>
        </Grid>
      </div>

      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>

      {/* OTP Dialog */}
      <Dialog
        open={otpCalled}
        onClose={handleCloseOtpDialog}
        PaperProps={{
          style: {
            backgroundColor: isDark ? '#111215' : '#ffffff',
            border: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)',
            borderRadius: '20px',
            padding: '10px',
            maxWidth: '400px',
            width: '100%'
          }
        }}
      >
        <DialogTitle style={{ fontFamily: 'Outfit, sans-serif', fontWeight: '700', color: isDark ? '#ffffff' : '#0F172A', textAlign: 'center' }}>
          {t('otp_here') || "Enter OTP"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="otp-input"
            variant="outlined"
            fullWidth
            className={classes.textField}
            label={t('otp') || "OTP"}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: { textAlign: 'center', fontSize: '1.2rem', letterSpacing: '4px', fontWeight: '600' }
            }}
            onChange={(e) => setOtp(e.target.value)}
            value={otp}
          />
        </DialogContent>
        <DialogActions style={{ padding: '16px', justifyContent: 'center' }}>
          {loading ? (
            <CircularProgress size={24} style={{ color: '#E9AE31' }} />
          ) : (
            <>
              <Button
                onClick={handleCloseOtpDialog}
                style={{
                  color: isDark ? '#ffffff' : '#0F172A',
                  textTransform: 'none',
                  fontWeight: '600',
                  borderRadius: '30px',
                  padding: '8px 20px',
                  border: isDark ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.15)',
                  background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'
                }}
              >
                {t('cancel') || "Cancel"}
              </Button>
              <Button
                onClick={handleVerifyOtp}
                style={{
                  background: 'linear-gradient(135deg, #FFD066 0%, #E9AE31 50%, #C28F1B 100%)',
                  color: '#0A0A0B',
                  textTransform: 'none',
                  fontWeight: '700',
                  borderRadius: '30px',
                  padding: '8px 24px',
                  boxShadow: '0 4px 15px rgba(233, 174, 49, 0.25)',
                  marginLeft: '12px'
                }}
              >
                {t('verify') || "Verify"}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
